import { render, staticRenderFns } from "./PaisesPasaporteForm.vue?vue&type=template&id=56ba4f2c&scoped=true"
import script from "./PaisesPasaporteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PaisesPasaporteForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PaisesPasaporteForm.vue?vue&type=style&index=0&id=56ba4f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba4f2c",
  null
  
)

export default component.exports